export default {
  'launchpad.title': 'Launchpad',
  'launchpad.eyebrow': 'Your Launchpad',

  'launchpad.module.processes.title': 'Processes',
  'launchpad.module.processes.eyebrow': 'Your processes hub',
  'launchpad.module.lists.title': 'Lists',
  'launchpad.module.lists.eyebrow': 'Your custom lists',
  'launchpad.module.reports.title': 'Reports',
  'launchpad.module.reports.eyebrow': 'Your reports hub',
  'launchpad.module.agents.title': 'Agents',
  'launchpad.module.agents.eyebrow': 'Your intelligent assistants',
  'launchpad.module.agents.tab.ai': 'AI Agents',
  'launchpad.module.agents.tab.rpa': 'RPA',
  'launchpad.module.agents.tab.skills': 'Skills',
  'launchpad.module.apps.title': 'Apps',
  'launchpad.module.apps.eyebrow': 'Your apps gallery',
  'launchpad.module.connections.title': 'Connections',
  'launchpad.module.connections.eyebrow': 'Your connections & integrations',
  'launchpad.module.entities.title': 'Entities',
  'launchpad.module.entities.eyebrow': 'Your dynamic data model',

  'launchpad.type.processes': 'Processes',
  'launchpad.type.processes.singular': 'Process',
  'launchpad.type.lists': 'Lists',
  'launchpad.type.lists.singular': 'List',
  'launchpad.type.reports': 'Reports',
  'launchpad.type.reports.singular': 'Report',
  'launchpad.type.agents': 'Agents',
  'launchpad.type.agents.singular': 'Agent',
  'launchpad.type.rpa': 'RPA',
  'launchpad.type.rpa.singular': 'RPA agent',
  'launchpad.type.skills': 'Skills',
  'launchpad.type.skills.singular': 'Skill',
  'launchpad.type.apps': 'Apps',
  'launchpad.type.apps.singular': 'App',
  'launchpad.type.connections': 'Connections',
  'launchpad.type.connections.singular': 'Connection',
  'launchpad.type.entities': 'Entities',
  'launchpad.type.entities.singular': 'Entity',

  'launchpad.switcher.aria': 'Switch content type',

  'launchpad.hero.welcome': 'Your workspace hub',
  'launchpad.hero.tagline.processes': 'Start processes, manage groups and favorites.',
  'launchpad.hero.tagline.lists': 'Browse lists, manage groups and favorites.',
  'launchpad.hero.tagline.reports': 'Query, filter and export reports.',
  'launchpad.hero.tagline.agents': 'Interact with AI agents and configure their behavior.',
  'launchpad.hero.tagline.rpa': 'Manage RPA agents, their status and configuration.',
  'launchpad.hero.tagline.skills': 'Configure skills, control their state and publish versions.',
  'launchpad.hero.tagline.apps': 'Open the apps enabled for your account.',
  'launchpad.hero.tagline.connections':
    'Manage credentials, validate status and configure integrations.',
  'launchpad.hero.tagline.entities': 'Manage dynamic entities, their groups and records.',

  'launchpad.subtitle.loading.processes': 'Loading processes and groups…',
  'launchpad.subtitle.loading.lists': 'Loading lists and groups…',
  'launchpad.subtitle.loading.reports': 'Loading reports and groups…',
  'launchpad.subtitle.loading.agents': 'Loading agents…',
  'launchpad.subtitle.loading.rpa': 'Loading RPA agents…',
  'launchpad.subtitle.loading.skills': 'Loading skills…',
  'launchpad.subtitle.loading.apps': 'Loading apps…',
  'launchpad.subtitle.loading.connections': 'Loading connections and groups…',
  'launchpad.subtitle.loading.entities': 'Loading entities and groups…',
  'launchpad.subtitle.loading': 'Loading processes and groups…',
  'launchpad.subtitle.counts':
    '{processes, plural, one {# process} other {# processes}} · {groups, plural, one {# group} other {# groups}}',

  'launchpad.kpi.processes': 'Processes',
  'launchpad.kpi.lists': 'Lists',
  'launchpad.kpi.reports': 'Reports',
  'launchpad.kpi.agents': 'Agents',
  'launchpad.kpi.rpa': 'RPA agents',
  'launchpad.kpi.skills': 'Skills',
  'launchpad.kpi.apps': 'Apps',
  'launchpad.kpi.connections': 'Connections',
  'launchpad.kpi.entities': 'Entities',
  'launchpad.kpi.groups': 'Groups',
  'launchpad.kpi.groups.agents': 'Teams',
  'launchpad.kpi.groups.skills': 'Groups',
  'launchpad.kpi.favorites': 'Favorites',

  'launchpad.density.comfy': 'Comfy',
  'launchpad.density.compact': 'Compact',
  'launchpad.density.aria': 'Change tile density',

  'launchpad.actions.refresh': 'Reload',
  'launchpad.actions.retry': 'Retry',
  'launchpad.actions.open': 'Open',
  'launchpad.actions.add': 'Add',
  'launchpad.actions.add.processes': 'Add process',
  'launchpad.actions.add.lists': 'Add list',
  'launchpad.actions.add.agents': 'Add agent',
  'launchpad.actions.add.rpa': 'Add RPA agent',
  'launchpad.actions.add.skills': 'Add skill',
  'launchpad.actions.import.skills': 'Import skill',
  'launchpad.actions.import.skillGroup': 'Import skill group',
  'launchpad.actions.add.apps': 'Add app',
  'launchpad.actions.add.connections': 'Add connection',
  'launchpad.actions.add.entities': 'Add entity',
  'launchpad.actions.addGroup.processes': 'Add group',
  'launchpad.actions.addGroup.lists': 'Add group',
  'launchpad.actions.addGroup.reports': 'Add group',
  'launchpad.actions.addGroup.connections': 'Add group',
  'launchpad.actions.addGroup.entities': 'Add group',
  'launchpad.actions.addGroup.agents': 'Add team',
  'launchpad.actions.addGroup.skills': 'Add group',
  'launchpad.actions.addSubgroup.processes': 'Add subgroup',
  'launchpad.group.actions.more': 'More group options',
  'launchpad.group.actions.detail': 'View details',
  'launchpad.group.actions.edit': 'Edit group',
  'launchpad.group.actions.delete': 'Delete group',
  'launchpad.group.actions.activate': 'Activate group',
  'launchpad.group.actions.deactivate': 'Deactivate group',
  'launchpad.group.delete.title': 'Delete group',
  'launchpad.group.delete.body':
    'Are you sure you want to delete the group "{name}"? This action cannot be undone.',

  'launchpad.status.inactive': 'Inactive',
  'launchpad.status.premium': 'Premium',
  'launchpad.connection.validated': 'Validated',
  'launchpad.connection.public': 'Public',
  'launchpad.actions.activate': 'Activate',
  'launchpad.actions.deactivate': 'Deactivate',

  'launchpad.kebab.details': 'Details',
  'launchpad.kebab.edit': 'Edit',
  'launchpad.kebab.configure': 'Configure',
  'launchpad.kebab.delete': 'Delete',
  'launchpad.kebab.permissions': 'Permissions',
  'launchpad.kebab.validate': 'Validate',
  'launchpad.kebab.taskTraces': 'Task traces',
  'launchpad.kebab.advancedConfig': 'Advanced configuration',
  'launchpad.kebab.diagram': 'Diagram',
  'launchpad.kebab.processConfig': 'Process configuration',

  'launchpad.search.placeholder': 'Search processes, groups or favorites…',
  'launchpad.search.placeholder.processes': 'Search processes, groups or favorites…',
  'launchpad.search.placeholder.lists': 'Search lists, groups or favorites…',
  'launchpad.search.placeholder.reports': 'Search reports, groups or favorites…',
  'launchpad.search.placeholder.agents': 'Search agents…',
  'launchpad.search.placeholder.rpa': 'Search RPA agents…',
  'launchpad.search.placeholder.skills': 'Search skills…',
  'launchpad.search.placeholder.apps': 'Search apps…',
  'launchpad.search.placeholder.connections': 'Search connections or groups…',
  'launchpad.search.placeholder.entities': 'Search entities, groups or premium…',

  'launchpad.search.clear': 'Clear search',
  'launchpad.search.empty': 'No results for your search',
  'launchpad.search.meta': '{processes} results · {groups} groups found',
  'launchpad.search.tag.favorite': 'Favorite',
  'launchpad.search.tag.group': 'Group',
  'launchpad.search.tag.process': 'Process',
  'launchpad.search.tag.processes': 'Process',
  'launchpad.search.tag.lists': 'List',
  'launchpad.search.tag.reports': 'Report',
  'launchpad.search.tag.agents': 'Agent',
  'launchpad.search.tag.rpa': 'RPA agent',
  'launchpad.search.tag.skills': 'Skill',
  'launchpad.search.tag.apps': 'App',
  'launchpad.search.tag.connections': 'Connection',
  'launchpad.search.tag.entities': 'Entity',
  'launchpad.search.hint.navigate': 'navigate',
  'launchpad.search.hint.activate': 'open',
  'launchpad.search.hint.close': 'close',

  'launchpad.progress.label': 'Loading {loaded} of {total} processes…',
  'launchpad.progress.processes': 'Loading {loaded} of {total} processes…',
  'launchpad.progress.lists': 'Loading {loaded} of {total} lists…',
  'launchpad.progress.reports': 'Loading {loaded} of {total} reports…',
  'launchpad.progress.agents': 'Loading {loaded} of {total} agents…',
  'launchpad.progress.rpa': 'Loading {loaded} of {total} RPA agents…',
  'launchpad.progress.skills': 'Loading {loaded} of {total} skills…',
  'launchpad.progress.apps': 'Loading {loaded} of {total} apps…',
  'launchpad.progress.connections': 'Loading {loaded} of {total} connections…',
  'launchpad.progress.entities': 'Loading {loaded} of {total} entities…',

  'launchpad.section.favorites': 'Favorites',
  'launchpad.section.groups': 'Groups',
  'launchpad.section.groups.agents': 'Teams',
  'launchpad.section.groups.skills': 'Groups',
  'launchpad.section.all': 'All processes',
  'launchpad.section.all.processes': 'All processes',
  'launchpad.section.all.lists': 'All lists',
  'launchpad.section.all.reports': 'All reports',
  'launchpad.section.all.agents': 'All agents',
  'launchpad.section.all.rpa': 'All RPA agents',
  'launchpad.section.all.skills': 'All skills',
  'launchpad.section.all.apps': 'All apps',
  'launchpad.section.all.connections': 'All connections',
  'launchpad.section.all.entities': 'All entities',
  'launchpad.section.results': 'Results',
  'launchpad.section.subgroups': 'Subgroups',
  'launchpad.section.processes': 'Processes',
  'launchpad.section.items.processes': 'Processes',
  'launchpad.section.items.lists': 'Lists',
  'launchpad.section.items.reports': 'Reports',
  'launchpad.section.items.agents': 'Agents',
  'launchpad.section.items.rpa': 'RPA agents',
  'launchpad.section.items.skills': 'Skills',
  'launchpad.section.items.apps': 'Apps',
  'launchpad.section.items.connections': 'Connections',
  'launchpad.section.items.entities': 'Entities',

  'launchpad.favorites.emptyTitle': "You don't have favorites yet",
  'launchpad.favorites.emptyHint': 'Star your most used processes to always keep them close.',
  'launchpad.favorites.emptyTitle.processes': "You don't have favorites yet",
  'launchpad.favorites.emptyHint.processes':
    'Star your most used processes to always keep them close.',
  'launchpad.favorites.emptyTitle.lists': "You don't have favorites yet",
  'launchpad.favorites.emptyHint.lists': 'Star your most used lists to always keep them close.',
  'launchpad.favorites.emptyTitle.reports': "You don't have favorites yet",
  'launchpad.favorites.emptyHint.reports': 'Star your most used reports to always keep them close.',
  'launchpad.favorites.emptyTitle.entities': "You don't have favorites yet",
  'launchpad.favorites.emptyHint.entities':
    'Star your most used entities to always keep them close.',

  'launchpad.rail.prev': 'Previous',
  'launchpad.rail.next': 'Next',

  'launchpad.group.open': 'Open group {name}',
  'launchpad.group.open.hint': 'Open',
  'launchpad.group.back': 'Back',
  'launchpad.group.backTo': 'Back to {name}',
  'launchpad.breadcrumb.home': 'Launchpad',
  'launchpad.group.meta':
    '{processes, plural, one {# process} other {# processes}}{subgroups, plural, =0 {} one { · # subgroup} other { · # subgroups}}',
  'launchpad.group.meta.processes':
    '{processes, plural, one {# process} other {# processes}}{subgroups, plural, =0 {} one { · # subgroup} other { · # subgroups}}',
  'launchpad.group.meta.lists':
    '{processes, plural, one {# list} other {# lists}}{subgroups, plural, =0 {} one { · # subgroup} other { · # subgroups}}',
  'launchpad.group.meta.reports':
    '{processes, plural, one {# report} other {# reports}}{subgroups, plural, =0 {} one { · # subgroup} other { · # subgroups}}',
  'launchpad.group.meta.connections':
    '{processes, plural, one {# connection} other {# connections}}{subgroups, plural, =0 {} one { · # subgroup} other { · # subgroups}}',
  'launchpad.group.meta.entities':
    '{processes, plural, one {# entity} other {# entities}}{subgroups, plural, =0 {} one { · # subgroup} other { · # subgroups}}',
  'launchpad.group.meta.agents':
    '{processes, plural, one {# agent} other {# agents}}{subgroups, plural, =0 {} one { · # subgroup} other { · # subgroups}}',
  'launchpad.group.meta.skills':
    '{processes, plural, one {# skill} other {# skills}}{subgroups, plural, =0 {} one { · # subgroup} other { · # subgroups}}',

  'launchpad.group.empty': 'This group has no available processes yet.',
  'launchpad.group.empty.processes': 'This group has no available processes yet.',
  'launchpad.group.empty.lists': 'This group has no available lists yet.',
  'launchpad.group.empty.reports': 'This group has no available reports yet.',
  'launchpad.group.empty.connections': 'This group has no available connections yet.',
  'launchpad.group.empty.entities': 'This group has no available entities yet.',
  'launchpad.group.empty.agents': 'This team has no agents assigned yet.',
  'launchpad.group.empty.skills': 'This group has no skills assigned yet.',

  'launchpad.group.processesCount': '{count, plural, one {# process} other {# processes}}',
  'launchpad.group.processesCount.processes':
    '{count, plural, one {# process} other {# processes}}',
  'launchpad.group.listsCount': '{count, plural, one {# list} other {# lists}}',
  'launchpad.group.reportsCount': '{count, plural, one {# report} other {# reports}}',
  'launchpad.group.connectionsCount': '{count, plural, one {# connection} other {# connections}}',
  'launchpad.group.entitiesCount': '{count, plural, one {# entity} other {# entities}}',
  'launchpad.group.agentsCount': '{count, plural, one {# agent} other {# agents}}',
  'launchpad.group.skillsCount': '{count, plural, one {# skill} other {# skills}}',
  'launchpad.group.subgroupsCount': '{count, plural, one {# subgroup} other {# subgroups}}',
  'launchpad.group.noProcesses': 'No content yet',

  'launchpad.filters.aria': 'Filter by group',
  'launchpad.filters.all': 'All',
  'launchpad.filters.favorites': 'Favorites',
  'launchpad.filters.system': 'System',
  'launchpad.filters.premium': 'Premium',
  'launchpad.filters.inactive': 'Inactive',
  'launchpad.agent.team': 'Team: {name}',
  'launchpad.skill.group': 'Group: {name}',

  'launchpad.grid.empty': 'No results match the current filters.',
  'launchpad.grid.loadingMore': 'Loading more…',

  'launchpad.process.start': 'Open {name}',
  'launchpad.favorite.add': 'Add to favorites',
  'launchpad.favorite.remove': 'Remove from favorites',

  'launchpad.error.load': 'Something went wrong loading your Launchpad. Please try again.',
};
